module.exports = __webpack_public_path__ + "img/5.a0c83af5.jpeg";